import { Fetch } from 'lib';
import type { SpecialOffer } from 'types';

type RequestResponses = SpecialOffer;

type RequestParameters = {};

type RequestBody = Prettify<
  Pick<SpecialOffer, 'title' | 'percent' | 'duration'> &
    Partial<Record<'productsIds' | 'brandsIds' | 'categoriesIds', string[]>>
>;

const createSpecialOffer = async (body: RequestBody) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminSpecialOffer/createSpecialOffer',
    method: 'POST',
    body,
  });

export { createSpecialOffer };
